import { useEffect, useState, useRef } from 'react';
import { TextField, Grid, Button, Typography, Box, Paper, Divider, CircularProgress, Dialog, DialogContent, DialogActions, IconButton, Tooltip, Autocomplete } from '@mui/material';
import { Snackbar, Alert } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import GetAppIcon from '@mui/icons-material/GetApp';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import CitySearchInput from "../components/CitySearchInput";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import InputAdornment from '@mui/material/InputAdornment';
import CityPopupModal from "../components/CityPopupModal";
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { useAuth } from '../context/AuthContext';
import { toProperCase } from '../utils/formatRows';
import CompanyDataManager from "./CompanyDataManager"; // ⭐ ADD THIS IMPORT
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import { IconButton } from '@mui/material';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { getCurrentFYear } from '../utils/financialYear';

const CompanyMaster = ({ mode, connectionString, onPopupCancel }) => {
    const { user, selectedCompany } = useAuth();
    const userId = user?.UserId || null;
    const companyId = selectedCompany?.CompId || null;
    const AppRegID = selectedCompany?.AppRegID || null;
    const API = `${connectionString}/api`;
    const { id } = useParams();
    console.log("company Id", companyId);
    const navigate = useNavigate();
    const EMAIL_SUGGESTIONS = ['nomail@gmail.com',];
    const [showEmailSuggestions, setShowEmailSuggestions] = useState(false);

    // UI / form states
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [showDataManager, setShowDataManager] = useState(false); // ⭐ ADD THIS STATE
    const [showPassword, setShowPassword] = useState({ eway: false, einvoice: false, });
    const [formState, setFormState] = useState({ gstNo: '', companyName: '', address: '', area: '', pinCode: '', city: '', state: '', stateCode: '', country: '', contactPerson: '', mobileNo: '', emailId: '', website: '', panNo: '', aadharNo: '', tanNo: '', msmeNo: '', cinNo: '', ieLicNo: '', postalAddress: '', EWBUserName: "", EWBPassword: "", EIUserName: "", EIPassword: "", BkName1: '', BkBranch1: '', BkAcNo1: '', BkIFSCCode1: '', UPIID: '' });

    const [city, setCity] = useState('');
    const [country, setCountry] = useState('');
    const [errors, setErrors] = useState({});
    const [formError, setFormError] = useState('');
    const [gstFetched, setGstFetched] = useState(false);
    const [showCityModal, setShowCityModal] = useState(false);
    const [isGstLoading, setIsGstLoading] = useState(false);
    const [stateField, setStateField] = useState("");
    const [stateCode, setStateCode] = useState("");
    const [cityQuery, setCityQuery] = useState("");
    const [selectedCity, setSelectedCity] = useState(null);
    const [cityDropdownOpen, setCityDropdownOpen] = useState(false);
    const [gstStatus, setGstStatus] = useState("");
    const [cities, setCities] = useState([]);
    const [cityValidationStatus, setCityValidationStatus] = useState({ isValid: true, missingCityState: null, message: "" });
    const [forceShowCityDropdown, setForceShowCityDropdown] = useState(false);
    const [imageRemoved, setImageRemoved] = useState(false);

    const fileInputRef = useRef(null);
    const signatureFileRef = useRef(null);

    // File upload states
    const [companyIcon, setCompanyIcon] = useState(null);
    const [companyIconPreview, setCompanyIconPreview] = useState(null);
    const [previewOpen, setPreviewOpen] = useState(false);

    // Signature upload states
    const [companySignature, setCompanySignature] = useState(null);
    const [companySignaturePreview, setCompanySignaturePreview] = useState(null);
    const [signatureRemoved, setSignatureRemoved] = useState(false);

    // API endpoints for image operations
    const IMAGE_INSERT_ENDPOINT = `${API}/company/InsertIcon`;
    const IMAGE_UPDATE_ENDPOINT = `${API}/company/UpdateIcon`;

    useEffect(() => {
        axios.get(`${API}/get-cities`).then(res => setCities(res.data.cities || [])).catch(error => console.error("Error fetching cities:", error));
    }, []);

    // Guard direct URL access to /main/newCompany — mirrors the backend's own
    // assertCompanyLimitNotReached check, so a user can't bypass the "Add
    // Company" button's pre-check by typing/bookmarking the URL directly.
    const [limitCheck, setLimitCheck] = useState({ checked: mode !== 'add', reached: false, count: 0, maxCompanies: null });
    useEffect(() => {
        if (mode !== 'add') return;
        if (!AppRegID) { setLimitCheck({ checked: true, reached: false, count: 0, maxCompanies: null }); return; }
        axios.get(`${API}/company/limit-status`, { params: { appRegId: AppRegID } })
            .then((res) => {
                const { count, maxCompanies, reached } = res.data;
                setLimitCheck({ checked: true, reached, count, maxCompanies });
            })
            .catch(() => setLimitCheck({ checked: true, reached: false, count: 0, maxCompanies: null }));
    }, [mode, AppRegID]);
    const requiredAsteriskStyle = { '& .MuiFormLabel-asterisk': { color: 'red', }, };
    const togglePassword = (key) => { setShowPassword((prev) => ({ ...prev, [key]: !prev[key], })); };

    useEffect(() => {
        if (mode === 'edit' && id) {
            axios.get(`${API}/company/getDetails/${id}`)
                .then(async (res) => {
                    const data = res.data || {};
                    setCity(data.City || '');
                    setStateField(data.State || '');
                    setStateCode(data.StateCode || '');

                    if (data.City) {
                        const cityObj = { city: data.City, state: data.State, stateCode: data.StateCode, country: data.Country };
                        setSelectedCity(cityObj);
                        setCityQuery(data.City);
                    } else {
                        setSelectedCity(null);
                        setCityQuery('');
                    }
                    setFormState(prev => ({ ...prev, gstNo: data.GSTNo || '', companyName: data.CompanyName || '', address: data.Address || '', area: data.Area || '', pinCode: data.Pincode || '', city: data.City || '', state: data.State || '', stateCode: data.StateCode || '', country: data.Country || '', contactPerson: data.ContactPerson || '', mobileNo: data.MobileNo || '', emailId: data.EmailId || '', website: data.Website || '', panNo: data.panno || '', aadharNo: data.AdharNo || '', tanNo: data.TANNo || '', msmeNo: data.MSMENo || '', cinNo: data.CINNo || '', ieLicNo: data.IELicNo || '', postalAddress: data.PostalAddress || '', EWBUserName: data.EWBUserName || '', EWBPassword: data.EWBPassword || '', EIUserName: data.EIUserName || '', EIPassword: data.EIPassword || '', BkName1: data.BkName1 || '', BkBranch1: data.BkBranch1 || '', BkAcNo1: data.BkAcNo1 || '', BkIFSCCode1: data.BkIFSCCode1 || '', UPIID: data.UPIID || '' }));
                    if (data.GSTNo && /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(data.GSTNo)) {
                        setGstFetched(true);
                    }

                    if (data.IconUrl) {
                        setCompanyIconPreview(data.IconUrl);
                        setCompanyIcon(null);
                    }

                    try {
                        const iconRes = await axios.get(`${API}/company/GetIcon/${encodeURIComponent(id)}`);
                        if (iconRes?.data?.success) {
                            if (iconRes.data.imageBase64) {
                                setCompanyIconPreview(iconRes.data.imageBase64);
                                setCompanyIcon(null);
                            } else {
                                setCompanyIconPreview(null);
                            }
                            // Load existing signature
                            if (iconRes.data.signatureBase64) {
                                setCompanySignaturePreview(iconRes.data.signatureBase64);
                                setCompanySignature(null);
                            } else {
                                setCompanySignaturePreview(null);
                            }
                        } else {
                            setCompanyIconPreview(null);
                        }
                    } catch (iconErr) {
                        // setSnackbar({ open: true, message: 'Failed to fetch company icon', severity: 'error' });
                        console.log('Failed to fetch company icon:', iconErr?.response?.data || iconErr.message);
                    }
                })
                .catch(err => {
                    setSnackbar({ open: true, message: 'Failed to load company details', severity: 'error' });
                    console.log('Fetch error:', err);
                });
        }
    }, [id, mode]);

    useEffect(() => { if (mode === 'edit' && selectedCity) setCityDropdownOpen(false); }, [selectedCity, mode]);

    useEffect(() => {
        if (mode === 'edit' && selectedCompany) {
            const data = selectedCompany;
            if (data?.City) {
                const cityObj = { city: data.City, state: data.State, stateCode: data.StateCode, country: data.Country };
                setSelectedCity(cityObj);
                setCityQuery(data.City);
            }
            setCityDropdownOpen(false);
        }
    }, [mode, selectedCompany]);

    // ── Resolve the plan (planName) of the company being EDITED (the `id` in
    // the URL), not necessarily the currently logged-in selectedCompany — an
    // admin can open any company's edit page while a different company is
    // selected. Used to hide TDS/Depreciation/Currency in CompanyDataManager
    // for "Billing" plan companies. `/All-companies` is the same endpoint the
    // login screen uses to compute planName per company (AppFeatures override
    // -> appregdetails.AppFeatures fallback), so this stays consistent.
    const [editingCompanyPlanName, setEditingCompanyPlanName] = useState(null);
    useEffect(() => {
        if (mode !== 'edit' || !id || !userId) return;
        let active = true;
        axios.get(`${API}/All-companies`, { params: { userId } })
            .then(res => {
                if (!active) return;
                const list = Array.isArray(res.data?.data) ? res.data.data : [];
                const match = list.find(c => String(c.CompId) === String(id));
                setEditingCompanyPlanName(match?.planName || null);
            })
            .catch(() => { if (active) setEditingCompanyPlanName(null); });
        return () => { active = false; };
    }, [mode, id, userId, API]);

    const properCaseFields = ["companyName", "address", "area", "country", "contactPerson", "postalAddress"];

    const handleChange = (e) => {
        const { name, value } = e.target;
        const formattedValue = properCaseFields.includes(name) ? toProperCase(value) : value;
        setFormState((prev) => ({ ...prev, [name]: formattedValue }));
        setErrors((prev) => ({ ...prev, [name]: "" }));
    };

    const handleGstChange = (e) => {
        const value = e.target.value.toUpperCase();
        setFormState(prev => ({ ...prev, gstNo: value }));

        // Only validate format, don't fetch yet
        const isValidGst = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(value);
        if (!isValidGst && value.length > 0) {
            setGstStatus(""); // Clear status if invalid
        }
    };

    const handleGstAutoFill = async () => {
        const { gstNo } = formState;
        const isValidGst = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gstNo);

        if (gstNo.length === 15 && isValidGst) {
            await fetchGstDetails(gstNo);
        } else {
            setSnackbar({ open: true, message: 'Please enter a valid 15-character GST No', severity: 'error' });
        }
    };

    const fetchGstDetails = async (gstNo) => {
        setIsGstLoading(true);
        try {
            const res = await axios.get(`${API}/gst-lookup`, { params: { searchGstin: gstNo } });
            const data = res.data?.data || {};
            console.log("gstData", data)
            setGstStatus(data.status || "");
            setFormState(prev => ({ ...prev, companyName: data.clientName || '', contactPerson: data.contactPerson || '', address: data.address || '', city: data.city || '', country: data.Country || '', mobileNo: data.mobileNo || '', emailId: data.emailId || '', pinCode: data.PinCode ? String(data.PinCode) : '', area: data.Area || data.landMark || data.street || '' }));

            if (data.city) {
                const cityObj = { city: data.city, state: data.state, stateCode: data.StateCode || gstNo.slice(0, 2), country: data.Country };
                setSelectedCity(cityObj);
                setCityQuery(data.city);
                setStateField(data.state || '');
                setStateCode(data.StateCode || gstNo.slice(0, 2));
                setCountry(data.Country || '');
                setFormState(prev => ({ ...prev, state: data.state || '', stateCode: data.StateCode || gstNo.slice(0, 2) }));

                const cityExists = cities?.find(c => c.city?.toLowerCase() === (data.city || "").toLowerCase() && c.state?.toLowerCase() === (data.state || "").toLowerCase());

                if (!cityExists && data.city && data.state) {
                    setCityValidationStatus({ isValid: false, missingCityState: { city: data.city, state: data.state }, message: `"${data.city}, ${data.state}" not found in database. Please add it first.` });
                    setForceShowCityDropdown(true);
                } else {
                    setCityValidationStatus({ isValid: true, missingCityState: null, message: "" });
                    setForceShowCityDropdown(false);
                }
            } else {
                setSelectedCity(null);
                setCityQuery('');
                setCityValidationStatus({ isValid: true, missingCityState: null, message: "" });
                setForceShowCityDropdown(false);
            }

            setSnackbar({ open: true, message: 'GST details fetched successfully', severity: 'success' });
            setGstFetched(true);
        } catch (err) {
            let msg = 'Unable to fetch details for given GST No.';
            if (err.response?.status === 400) msg = err.response.data?.message || 'GST lookup failed';
            else if (err.response?.status === 403) msg = 'GST is not Active';
            setSnackbar({ open: true, message: msg, severity: 'error' });
            setGstFetched(false);
            setGstStatus("");
        } finally {
            setIsGstLoading(false);
        }
    };

    const handleCityAdded = (newCity) => {
        setSelectedCity(newCity);
        setFormState(prev => ({ ...prev, city: newCity.city, state: newCity.state, stateCode: newCity.stateCode, country: newCity.country }));
        setStateField(newCity.state);
        setStateCode(newCity.stateCode);
        setCountry(newCity.country);
        setCityQuery(newCity.city);
        setShowCityModal(false);
    };

    // Center-crop a File to targetW × targetH, returns a cropped PNG data URL.
    // If the image is smaller than the target in either dimension, scale it up
    // just enough to fill, then extract the center rectangle.
    const centerCropImage = (file, targetW, targetH) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onerror = reject;
            reader.onloadend = () => {
                const img = new Image();
                img.onerror = reject;
                img.onload = () => {
                    let srcW = img.naturalWidth;
                    let srcH = img.naturalHeight;

                    // Scale up if either dimension is smaller than target
                    let drawImg = img;
                    if (srcW < targetW || srcH < targetH) {
                        const scale = Math.max(targetW / srcW, targetH / srcH);
                        const scaledW = Math.ceil(srcW * scale);
                        const scaledH = Math.ceil(srcH * scale);
                        const scaleCanvas = document.createElement('canvas');
                        scaleCanvas.width = scaledW;
                        scaleCanvas.height = scaledH;
                        scaleCanvas.getContext('2d').drawImage(img, 0, 0, scaledW, scaledH);
                        srcW = scaledW;
                        srcH = scaledH;
                        drawImg = scaleCanvas;
                    }

                    // Extract center rectangle
                    const left = Math.floor((srcW - targetW) / 2);
                    const top  = Math.floor((srcH - targetH) / 2);
                    const canvas = document.createElement('canvas');
                    canvas.width  = targetW;
                    canvas.height = targetH;
                    canvas.getContext('2d').drawImage(drawImg, left, top, targetW, targetH, 0, 0, targetW, targetH);
                    resolve(canvas.toDataURL('image/png'));
                };
                img.src = reader.result;
            };
            reader.readAsDataURL(file);
        });

    const LOGO_WIDTH = 150;
    const LOGO_HEIGHT = 90;

    const handleFileChange = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        if (!file.type.startsWith('image/')) {
            setSnackbar({ open: true, message: 'Only image files are allowed!', severity: 'error' });
            return;
        }
        try {
            const croppedDataUrl = await centerCropImage(file, LOGO_WIDTH, LOGO_HEIGHT);
            const blob = await (await fetch(croppedDataUrl)).blob();
            // Upload the cropped 150x90 image so the PDF matches the preview
            setCompanyIcon(new File([blob], 'company_logo.png', { type: 'image/png' }));
            setCompanyIconPreview(croppedDataUrl);
        } catch (err) {
            // Fallback: show original preview if crop fails
            setCompanyIcon(file);
            const reader = new FileReader();
            reader.onloadend = () => setCompanyIconPreview(reader.result);
            reader.readAsDataURL(file);
        }
    };

    // const handleRemoveImage = () => {
    //     setCompanyIcon(null);
    //     setCompanyIconPreview(null);
    // };

    // Update the handleRemoveImage function
    const handleRemoveImage = () => {
        setCompanyIcon(null);
        setCompanyIconPreview(null);
        setImageRemoved(true);  // ✅ Mark as removed

        try {
            if (fileInputRef && fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        } catch (e) {
            console.warn('Could not clear file input value', e);
            setSnackbar({ open: true, message: 'Could not clear file input value', severity: 'error' });
        }
        setSnackbar({ open: true, message: 'Image removed', severity: 'info' });
    };

    const handleSignatureFileChange = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        if (!file.type.startsWith('image/')) {
            setSnackbar({ open: true, message: 'Only image files are allowed!', severity: 'error' });
            return;
        }
        setCompanySignature(file);
        setSignatureRemoved(false);
        try {
            const croppedDataUrl = await centerCropImage(file, 120, 55);
            setCompanySignaturePreview(croppedDataUrl);
        } catch (err) {
            // Fallback: show original preview if crop fails
            const reader = new FileReader();
            reader.onloadend = () => setCompanySignaturePreview(reader.result);
            reader.readAsDataURL(file);
        }
    };

    const handleSignatureRemove = () => {
        setCompanySignature(null);
        setCompanySignaturePreview(null);
        setSignatureRemoved(true);
        try { if (signatureFileRef.current) signatureFileRef.current.value = ''; } catch (e) {}
        setSnackbar({ open: true, message: 'Signature removed', severity: 'info' });
    };

    const openPreview = () => {
        if (!companyIconPreview) return;
        setPreviewOpen(true);
    };
    const closePreview = () => setPreviewOpen(false);

    const validate = () => {
        const newErrors = {};
        const { gstNo, companyName, contactPerson, mobileNo, pinCode, emailId, website, panNo, aadharNo, city, BkAcNo1, BkIFSCCode1 } = formState;
        if (!companyName) newErrors.companyName = 'Company Name is required';
        if (!contactPerson) newErrors.contactPerson = 'Contact Person is required';
        if (gstNo && !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gstNo)) newErrors.gstNo = 'Invalid GST No';
        if (emailId && !/^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(emailId)) newErrors.emailId = 'Invalid Email';
        if (website && !/^((http|https):\/\/)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/.test(website)) newErrors.website = 'Invalid Website';
        if (panNo && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(panNo)) newErrors.panNo = 'Invalid PAN No';
        if (aadharNo && !/^\d{12}$/.test(aadharNo)) newErrors.aadharNo = 'Invalid Aadhar No';
        if (!city) newErrors.city = 'City is required';
        if (pinCode && pinCode.length < 6) newErrors.pinCode = 'Pincode must be 6 digits';
        if (pinCode && pinCode.length < 6) {
            newErrors.pinCode = 'Pincode must be 6 digits';
        } else if (pinCode && !/^\d{6}$/.test(pinCode)) {
            newErrors.pinCode = 'Invalid Pincode';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleBlur = (e) => {
        const { name, value } = e.target;
        let errorMsg = "";

        // ✅ Account No validation
        if (name === "BkAcNo1" && value) {
            if (!/^\d+$/.test(value)) {
                errorMsg = "Account No must contain only digits";
            } else if (value.length < 9 || value.length > 18) {
                errorMsg = "Account No must be between 9 to 18 digits";
            }
        }

        // ✅ IFSC validation
        if (name === "BkIFSCCode1" && value) {
            const isValidLength = value.length === 11;
            const hasLetter = /[A-Za-z]/.test(value);
            const hasDigit = /\d/.test(value);
            const isAlphanumeric = /^[A-Za-z0-9]+$/.test(value);

            if (!isValidLength) {
                errorMsg = "IFSC Code must be 11 characters";
            } else if (!isAlphanumeric) {
                errorMsg = "IFSC must contain only letters and digits";
            } else if (!hasLetter || !hasDigit) {
                errorMsg = "IFSC must contain at least 1 letter and 1 digit";
            }
        }

        setErrors(prev => ({ ...prev, [name]: errorMsg }));
    };

    const handleReset = () => {
        setFormState({ gstNo: '', companyName: '', address: '', area: '', pinCode: '', city: '', state: '', stateCode: '', country: '', contactPerson: '', mobileNo: '', emailId: '', website: '', panNo: '', aadharNo: '', tanNo: '', msmeNo: '', cinNo: '', ieLicNo: '', postalAddress: '', EWBUserName: "", EWBPassword: "", EIUserName: "", EIPassword: "", BkName1: '', BkBranch1: '', BkAcNo1: '', BkIFSCCode1: '', UPIID: '' });
        setErrors({});
        setFormError('');
        setCompanyIcon(null);
        setCompanyIconPreview(null);
        setImageRemoved(false);
        setCompanySignature(null);
        setCompanySignaturePreview(null);
        setSignatureRemoved(false);
        // navigate(-1)
    };

    const uploadIconForInsert = async (companyId, file) => {
        if (!companyId || !file) throw new Error('Missing companyId or file for insert upload');
        setIsUploading(true);
        try {
            const base64 = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });

            // Include signature base64 if a signature file was selected
            let signatureBase64 = undefined;
            if (companySignature) {
                signatureBase64 = await new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(companySignature);
                });
            }

            const res = await axios.post(IMAGE_INSERT_ENDPOINT,
                { companyId: String(companyId), imageBase64: base64, AppRegID, ...(signatureBase64 ? { signatureBase64 } : {}) },
                { headers: { 'Content-Type': 'application/json' } }
            );
            setSnackbar({ open: true, message: 'Icon uploaded (insert) successfully', severity: 'success' });
            return res.data;
        } catch (err) {
            setSnackbar({ open: true, message: 'Icon upload (insert) failed', severity: 'error' });
            throw err;
        } finally {
            setIsUploading(false);
        }
    };

    const uploadIconForUpdate = async (companyId, file) => {
        if (!companyId || !file) throw new Error('Missing companyId or file for update upload');
        setIsUploading(true);
        try {
            const fd = new FormData();
            fd.append('icon', file);
            // Include signature data if a new signature was selected
            if (companySignature) {
                const sigBase64 = await new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(companySignature);
                });
                fd.append('signatureBase64', sigBase64);
            }
            // Include deleteSignature flag if signature was removed
            if (signatureRemoved && !companySignature) {
                fd.append('deleteSignature', 'true');
            }
            const url = `${IMAGE_UPDATE_ENDPOINT}/${encodeURIComponent(companyId)}`;
            const res = await axios.put(url, fd, { headers: { 'Content-Type': 'multipart/form-data' }, });
            setSnackbar({ open: true, message: 'Icon uploaded (update) successfully', severity: 'success' });
            return res.data;
        } catch (err) {
            // console.error('Update icon upload failed:', err);
            setSnackbar({ open: true, message: 'Icon upload (update) failed', severity: 'error' });
            throw err;
        } finally {
            setIsUploading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) {
            setFormError('* Please fix validation errors before submitting.');
            return;
        }

        if (!cityValidationStatus.isValid) {
            setFormError('Please add the missing city to database before saving.');
            return;
        }

        setIsSubmitting(true);
        setFormError('');
        try {
            const { gstNo, companyName, address, area, pinCode, city, state, stateCode, country, contactPerson, mobileNo, emailId, website, panNo, aadharNo, tanNo, msmeNo, cinNo, ieLicNo, postalAddress, EWBUserName, EWBPassword, EIUserName, EIPassword, BkName1, BkBranch1, BkAcNo1, BkIFSCCode1, UPIID } = formState;
            const payload = { gstInNumber: gstNo, companyName, address, area, pincode: pinCode, city, state, stateCode, country, contactPerson, mobileno: mobileNo, emailId, website, panno: panNo, adharno: aadharNo, tanNo, msmeNo, cinNo, ieLicNo, postalAddress, fYear: getCurrentFYear(), userId, companyId, AppRegID, EWBUserName, EWBPassword, EIUserName, EIPassword, BkName1, BkBranch1, BkAcNo1, BkIFSCCode1, UPIID };
            console.log("payload in company", payload)
            if (mode === 'add') {
                const res = await axios.post(`${API}/company/Insert`, payload);
                const data = res?.data || {};
                const createdId = data.companyId || data.id || data.CompId || data.insertId || data.data?.companyId || data.data?.id;
                if (!createdId) {
                    // console.warn('Insert succeeded but no companyId returned. Response:', data);
                    setSnackbar({ open: true, message: 'Company created but server did not return companyId. Icon not uploaded.', severity: 'warning' });
                } else {
                    if (companyIcon) {
                        try {
                            await uploadIconForInsert(createdId, companyIcon);
                        } catch (uploadErr) {
                            // handled in helper
                        }
                    } else if (companySignature) {
                        // Signature only, no icon — InsertIcon requires an icon file, so it
                        // can't be used here. UpdateIcon already knows how to create a fresh
                        // company_icons row when none exists yet, so reuse that instead.
                        try {
                            const sigBase64 = await new Promise((resolve, reject) => {
                                const reader = new FileReader();
                                reader.onloadend = () => resolve(reader.result);
                                reader.onerror = reject;
                                reader.readAsDataURL(companySignature);
                            });
                            await axios.put(
                                `${API}/company/UpdateIcon/${encodeURIComponent(createdId)}`,
                                { signatureBase64: sigBase64 },
                                { headers: { 'Content-Type': 'application/json' } }
                            );
                        } catch (sigErr) {
                            console.error('Signature-only insert failed:', sigErr);
                            setSnackbar({ open: true, message: 'Signature upload failed', severity: 'error' });
                        }
                    }
                }
                setSnackbar({ open: true, message: `Data inserted successfully`, severity: 'success' })
                handleReset();
                // navigate back / close popup after 5 seconds
                setTimeout(() => {
                    if (typeof onPopupCancel === "function") onPopupCancel();
                    else navigate(-1);
                }, 500);
            } else {
                await axios.put(`${API}/company/Update/${id}`, payload);

                // ✅ NEW: If image was removed, delete it from backend
                if (imageRemoved) {
                    try {
                        await axios.put(
                            `${API}/company/UpdateIcon/${encodeURIComponent(id)}`,
                            { deleteImage: true },
                            { headers: { 'Content-Type': 'application/json' } }
                        );
                        console.log('Image deleted from backend');
                    } catch (deleteErr) {
                        console.error('Error deleting image:', deleteErr);
                        setSnackbar({ open: true, message: 'Failed to remove image from server', severity: 'error' });
                    }
                }

                // ✅ If new image was selected, upload it (signature included inside uploadIconForUpdate)
                if (companyIcon) {
                    try {
                        await uploadIconForUpdate(id, companyIcon);
                    } catch (uploadErr) {
                        // handled in helper
                    }
                } else if (companySignature) {
                    // Signature changed but icon did not — signature-only update
                    try {
                        const sigBase64 = await new Promise((resolve, reject) => {
                            const reader = new FileReader();
                            reader.onloadend = () => resolve(reader.result);
                            reader.onerror = reject;
                            reader.readAsDataURL(companySignature);
                        });
                        await axios.put(
                            `${API}/company/UpdateIcon/${encodeURIComponent(id)}`,
                            { signatureBase64: sigBase64 },
                            { headers: { 'Content-Type': 'application/json' } }
                        );
                    } catch (sigErr) {
                        console.error('Signature-only update failed:', sigErr);
                        setSnackbar({ open: true, message: 'Signature update failed', severity: 'error' });
                    }
                } else if (signatureRemoved) {
                    // Signature removed, icon unchanged — signature-only delete
                    try {
                        await axios.put(
                            `${API}/company/UpdateIcon/${encodeURIComponent(id)}`,
                            { deleteSignature: true },
                            { headers: { 'Content-Type': 'application/json' } }
                        );
                    } catch (sigErr) {
                        console.error('Signature delete failed:', sigErr);
                        setSnackbar({ open: true, message: 'Signature removal failed', severity: 'error' });
                    }
                }

                setSnackbar({ open: true, message: `Data Updated successfully`, severity: 'success' });
                handleReset();
                setImageRemoved(false);  // ✅ Reset flag
                setTimeout(() => {
                    if (typeof onPopupCancel === "function") onPopupCancel();
                    else navigate(-1);
                }, 500);
            }
        } catch (err) {
            // console.error('Submission error:', err);
            setSnackbar({ open: true, message: `Error ${mode === 'add' ? 'inserting' : 'updating'} data`, severity: 'error' });
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleCancel = () => {
        handleReset();
        if (typeof onPopupCancel === "function") {
            onPopupCancel();
        } else {
            navigate(-1);
        }
    };

    // ──────────────── Alt+S (Save/Update) & Alt+C (Cancel) shortcuts ────────────────
    // Attached to document in the capture phase so it fires regardless of which
    // field/dropdown currently has focus, including MUI popper/portal content.
    // Uses e.code (physical key position) instead of e.key so this also works on
    // macOS, where Option+letter often produces an accented/dead-key character
    // via e.key (e.g. Option+C → "ç") instead of the plain letter.
    // Guarded by `showDataManager`: this component early-returns to render
    // <CompanyDataManager> instead of its own form when true, but hooks still run
    // on every render regardless — without this guard, this listener would keep
    // firing (and navigating away) while a nested master popup inside
    // CompanyDataManager is open and handling its own Alt+S/Alt+C independently.
    useEffect(() => {
        if (showDataManager) return;

        const handleGlobalKeyDown = (e) => {
            if (!e.altKey) return;

            if (e.code === "KeyS") {
                e.preventDefault();
                if (!isSubmitting && !isUploading) {
                    handleSubmit(e);
                }
            } else if (e.code === "KeyC") {
                e.preventDefault();
                handleCancel();
            }
        };

        document.addEventListener("keydown", handleGlobalKeyDown, true);
        return () => document.removeEventListener("keydown", handleGlobalKeyDown, true);
    });

    const renderField = (label, name, required = false, multiline = false, gridProps = { xs: 12, md: 6 }, boxProps = {}) => (
        <Grid item {...gridProps} key={name} >
            <Box {...boxProps} >
                <TextField fullWidth label={label} name={name} size="small" value={
                    properCaseFields.includes(name) ? toProperCase(formState[name] ?? "") : formState[name] ?? ""
                } onChange={handleChange} onBlur={handleBlur} error={!!errors[name]
                } helperText={errors[name] || ''} required={required} multiline={multiline} minRows={multiline ? 2.1 : undefined} sx={{ ...(required ? requiredAsteriskStyle : {}), '& .MuiInputBase-root': { height: multiline ? 'auto' : 38, alignItems: 'center', borderRadius: 2, }, '& .MuiInputBase-input': { padding: '10px 14px', }, }} />
            </Box>
        </Grid>
    );

    const downloadPreview = () => {
        if (!companyIconPreview) return;
        const link = document.createElement('a');
        link.href = companyIconPreview;
        link.download = `company_icon${companyIconPreview.startsWith('data:') ? '.png' : ''}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // ⭐ SHOW DATA MANAGER IF TOGGLED
    if (showDataManager) {
        return (<CompanyDataManager companyId={id || companyId} planName={editingCompanyPlanName} setSnackbar={setSnackbar} connectionString={connectionString} onBack={() => setShowDataManager(false)} />);
    }

    // Block direct URL access to the create form once this AppRegID's plan is
    // at its company cap — the "Add Company" button already checks this
    // before navigating, but a bookmarked/typed URL would skip that check.
    if (mode === 'add' && limitCheck.checked && limitCheck.reached) {
        return (
            <Paper elevation={3} sx={{ p: 4, mt: 1.5, mb: 1, maxWidth: 500, mx: 'auto', textAlign: 'center' }}>
                <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>Company Limit Reached</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    You've reached your plan's company limit ({limitCheck.count}/{limitCheck.maxCompanies}).
                    Upgrade your plan to add more companies.
                </Typography>
                <Button variant="contained" onClick={handleCancel}>Back</Button>
            </Paper>
        );
    }

    return (
        <Paper elevation={3} sx={{ p: 2, mt: 1.5, mb: 1, maxWidth: 900, mx: 'auto' }}>
            < Box component="form" onSubmit={handleSubmit} >
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1, }} >
                    {/* Left spacer (keeps title centered visually) */}
                    {/* <Box sx={{ width: 120 }} /> */}
                    {/* Back Button */}
                    <IconButton onClick={handleCancel} sx={{ width: 40, height: 40 }} > <ArrowBackIcon /> </IconButton>

                    {/* Title */}
                    <Typography variant="h5" sx={{ textAlign: 'center', fontSize: { xs: '1.25rem', sm: '1.5rem' }, fontWeight: 600, }} > {mode === 'add' ? 'Add New Company' : 'Edit Company'} </Typography>

                    {/* Settings Button (Top Right) */}
                    {mode === 'edit' ? (
                        <Button variant="outlined" color="secondary" onClick={() => setShowDataManager(true)} sx={{ height: 32 }} >
                            Settings
                        </Button>
                    ) : (
                        <Box sx={{ width: 120 }} />
                    )}
                </Box>

                < Box display='flex' flexWrap='wrap' gap={1.5} sx={{ px: 1 }}>
                    <Box sx={{ flex: { xs: "100%", md: "48%" }, display: "flex", flexDirection: "column", gap: 1.3 }}>
                        <Box sx={{ flex: 1 }}>
                            <TextField label="GST No" name="gstNo" value={formState.gstNo} onChange={handleGstChange} fullWidth inputProps={{ maxLength: 15 }} error={!!errors.gstNo} size="small" helperText={errors.gstNo || ''}
                                sx={{ '& .MuiInputBase-root': { height: 38, alignItems: 'center', borderRadius: 2 }, '& .MuiInputBase-input': { padding: '10px 14px', fontSize: '0.875rem' } }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Button variant="outlined" size="small" onClick={handleGstAutoFill} disabled={isGstLoading || formState.gstNo.length !== 15} sx={{ height: 32, mr: -1, fontSize: '0.75rem', textTransform: 'none' }} >
                                                {isGstLoading ? <CircularProgress size={16} sx={{ mr: 0.5 }} /> : 'Verify'}
                                            </Button>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>
                        {gstStatus && gstStatus !== "Active" && (<Typography variant="caption" sx={{ mt: -1.5, color: "error.main", display: "block", }} > GST Status: {gstStatus} </Typography>)}
                        {renderField('Company Name', 'companyName', true)}
                        {renderField('Address', 'address', false, true, { xs: 12, md: 6 }, { sx: { '& .MuiInputBase-root:not(.MuiInputBase-multiline)': { height: 38, }, '& .MuiOutlinedInput-inputMultiline': { padding: '8px 2px', minHeight: '80px', }, }, })}
                        <Box display="flex" gap={1} width="100%" >
                            <Box flex={1}> <TextField fullWidth label="Area" name="area" size="small" value={toProperCase(formState.area)} onChange={handleChange} sx={{ '& .MuiInputBase-root': { height: 38, borderRadius: 2 }, '& .MuiInputBase-input': { padding: '10px 14px' }, }} /> </Box>
                            < Box flex={1} >
                                <TextField fullWidth label="Pincode" name="pinCode" size="small" required value={formState.pinCode} onChange={(e) => {
                                    const onlyDigits = e.target.value.replace(/\D/g, '').slice(0, 6);
                                    setFormState((prev) => ({ ...prev, pinCode: onlyDigits }));
                                    if (onlyDigits.length > 0 && onlyDigits.length < 6) {
                                        setErrors((prev) => ({ ...prev, pinCode: 'Pincode must be 6 digits' }));
                                    } else {
                                        setErrors((prev) => ({ ...prev, pinCode: '' }));
                                    }
                                }} error={!!errors.pinCode} helperText={errors.pinCode || ''} InputLabelProps={{ sx: { '& .MuiFormLabel-asterisk': { color: 'red', }, }, }} sx={{ '& .MuiInputBase-root': { height: 38, borderRadius: 2 }, '& .MuiInputBase-input': { padding: '10px 14px' }, }} />
                            </Box>
                        </Box>

                        < Box display="flex" gap={1} >
                            <Box flex={1}>
                                <CitySearchInput value={selectedCity?.city || cityQuery} connectionString={connectionString} forceShowDropdown={forceShowCityDropdown} validationStatus={cityValidationStatus} showWarning={!cityValidationStatus.isValid}
                                    onSelectCity={(c) => {
                                        setSelectedCity(c);
                                        setFormState(f => ({ ...f, city: c.city, state: c.state, stateCode: c.stateCode, country: c.country }));
                                        setStateField(c.state);
                                        setStateCode(c.stateCode);
                                        setCountry(c.country);
                                        setCityQuery(c.city);
                                        setCityValidationStatus({ isValid: true, missingCityState: null, message: "" });
                                        setForceShowCityDropdown(false);
                                        setCityDropdownOpen(false);
                                    }}
                                    onChangeQuery={(q) => {
                                        setCityQuery(q);
                                        setSelectedCity(null);
                                        if (mode === 'add') setCityDropdownOpen(true);
                                    }}
                                />
                            </Box>

                            <Box display="flex" flex={1} gap={1} >
                                <Box flex={0.6}> <TextField label="State" name="state" required value={stateField} size="small" disabled fullWidth InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiInputBase-root': { height: 38 }, '& .MuiInputLabel-root': { lineHeight: '1.2em' } }} /></Box >
                                <Box flex={0.4}> <TextField label="State Code" name="stateCode" required value={stateCode} size="small" disabled fullWidth InputLabelProps={{ sx: requiredAsteriskStyle }} error={stateCode?.length > 2} sx={{ '& .MuiInputBase-root': { height: 38, border: (theme) => stateCode?.length > 2 ? `1px solid ${theme.palette.error.main}` : undefined }, '& .Mui-disabled': { WebkitTextFillColor: 'rgba(0,0,0,0.87)' } }} /></Box >
                            </Box>
                        </Box>

                        <TextField fullWidth label="Country" name="country" value={formState.country} disabled required size="small" InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiInputBase-root': { height: 40, borderRadius: 2, }, '& .MuiInputBase-input': { padding: '10px 14px', }, }} />

                        <Box>
                            {renderField('Contact Person', 'contactPerson', true, false, { sx: { mb: 1.3 } })}
                            < TextField fullWidth label="Mobile No." size="small" name="mobileNo" value={formState.mobileNo} onBlur={handleBlur} onChange={(e) => {
                                setFormState((prev) => ({ ...prev, mobileNo: e.target.value }));
                            }} error={!!errors.mobileNo} helperText={errors.mobileNo || ''} sx={{ '& .MuiInputBase-root': { height: 38, alignItems: 'center', borderRadius: 2 }, '& .MuiInputBase-input': { padding: '10px 14px', fontSize: '0.875rem' } }} />
                        </Box>
                    </Box>

                    < Box sx={{ flex: { xs: "100%", md: "48%" }, display: "flex", flexDirection: "column", gap: 1.5 }}>
                        <Box>
                            {
                                < Grid item xs={12} md={6} >
                                    <Box sx={{ position: 'relative', mb: 1.3 }}>
                                        <TextField fullWidth label="Email" name="emailId" size="small" value={formState.emailId || ''} onChange={handleChange} onFocus={() => setShowEmailSuggestions(true)} onBlur={() => { setTimeout(() => setShowEmailSuggestions(false), 150); }} error={!!errors.emailId} helperText={errors.emailId || ''} required InputLabelProps={{ sx: { '& .MuiFormLabel-asterisk': { color: 'red', }, }, }} sx={{ '& .MuiInputBase-root': { height: 38, borderRadius: 2, }, '& .MuiInputBase-input': { padding: '10px 14px', }, }} />

                                        {/* Tooltip-like suggestions */}
                                        {
                                            showEmailSuggestions && (
                                                <Box sx={{ position: 'absolute', top: 'calc(100% + 8px)', left: 12, bgcolor: '#fff', borderRadius: 2, px: 1, py: 0.5, zIndex: 20, boxShadow: '0px 6px 18px rgba(0,0,0,0.15)', minWidth: 260, }} >
                                                    {/* Arrow */}
                                                    <Box sx={{ position: 'absolute', top: -6, left: 16, width: 12, height: 12, bgcolor: '#fff', transform: 'rotate(45deg)', boxShadow: '-2px -2px 4px rgba(0,0,0,0.04)', }} />
                                                    {
                                                        ['nomail@gmail.com']
                                                            .filter(item => !formState.emailId || item.toLowerCase().includes(formState.emailId.toLowerCase()))
                                                            .map(item => (
                                                                <Box key={item} sx={{ px: 1.5, py: 0.75, fontSize: 13, borderRadius: 1, cursor: 'pointer', whiteSpace: 'nowrap', '&:hover': { backgroundColor: '#f0f4ff', }, }}
                                                                    onMouseDown={() => { handleChange({ target: { name: 'emailId', value: item }, }); }}
                                                                >
                                                                    {item}
                                                                </Box>
                                                            ))}
                                                </Box>
                                            )}
                                    </Box>
                                </Grid>

                            }
                            {renderField('Website', 'website', false, false, { sx: { mb: 1.3 } })}
                            <Box display="flex" gap={1} width="100%">
                                <Box flex={1}> {renderField('PAN No.', 'panNo', false, false, { xs: 12, md: 12 }, { sx: { mb: 1.3 } })} </Box>
                                <Box flex={1}> {renderField('Aadhar No.', 'aadharNo', false, false, { xs: 12, md: 12 }, { sx: { mb: 1.3 } })} </Box>
                            </Box>
                            {renderField('TAN No', 'tanNo', false, false, { sx: { mb: 1.3 } })}
                            {renderField('MSME No', 'msmeNo', false, false, { sx: { mb: 1.3 } })}
                            {renderField('CIN No', 'cinNo', false, false, { sx: { mb: 1.3 } })}
                            {renderField('I.E. No', 'ieLicNo', false, false, { sx: { mb: 1.3 } })}
                            {renderField('Postal Address', 'postalAddress', false, true, { xs: 12, md: 6 }, { sx: { '& .MuiInputBase-root:not(.MuiInputBase-multiline)': { height: 38 }, '& .MuiOutlinedInput-inputMultiline': { padding: '8px 2px', minHeight: '80px' } } })}
                        </Box>
                    </Box>
                </Box>

                {formError && (<Typography color="error" sx={{ mt: 2, textAlign: 'center', fontWeight: 'bold' }}> {formError} </Typography>)}

                {/* E-Way Bill & E-Invoice Credentials Card */}
                <Box sx={{ mt: 2, mb: 2 }}>
                    <Paper elevation={2} sx={{ p: 2, borderRadius: 2, border: '1px solid #e0e0e0' }} >
                        <Box display='flex' flexWrap='wrap' gap={2}>
                            {/* Left Section - E-Way Bill */}
                            <Box sx={{ flex: { xs: "100%", md: "48%" } }}>
                                <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 600, color: 'text.secondary' }} > E-Way Bill Details </Typography>
                                <Box display="flex" flexDirection="column" gap={1.3}>
                                    <TextField fullWidth label="Username" name="EWBUserName" size="small" value={formState.EWBUserName || ''} onChange={handleChange} sx={{ '& .MuiInputBase-root': { height: 38, borderRadius: 2, }, '& .MuiInputBase-input': { padding: '10px 14px', }, }} />
                                    <TextField fullWidth label="Password" name="EWBPassword" type={showPassword.eway ? "text" : "password"} size="small" value={formState.EWBPassword || ''} onChange={handleChange} sx={{ '& .MuiInputBase-root': { height: 38, borderRadius: 2, }, '& .MuiInputBase-input': { padding: '10px 14px', }, }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton onClick={() => togglePassword("eway")} edge="end" size="small" > {showPassword.eway ? <VisibilityOff /> : <Visibility />} </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                            </Box>

                            {/* Right Section - E-Invoice */}
                            <Box sx={{ flex: { xs: "100%", md: "48%" } }}>
                                <Typography
                                    variant="subtitle2"
                                    sx={{
                                        mb: 1.5,
                                        fontWeight: 600,
                                        color: 'text.secondary'
                                    }}
                                >
                                    E-Invoice Details
                                </Typography>

                                <Box display="flex" flexDirection="column" gap={1.3}>
                                    <TextField fullWidth label="Username" name="EIUserName" size="small" value={formState.EIUserName || ''} onChange={handleChange} sx={{ '& .MuiInputBase-root': { height: 38, borderRadius: 2, }, '& .MuiInputBase-input': { padding: '10px 14px', }, }} />
                                    <TextField fullWidth label="Password" name="EIPassword" type={showPassword.einvoice ? "text" : "password"} size="small" value={formState.EIPassword || ''} onChange={handleChange} sx={{ '& .MuiInputBase-root': { height: 38, borderRadius: 2, }, '& .MuiInputBase-input': { padding: '10px 14px', }, }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton onClick={() => togglePassword("einvoice")} edge="end" size="small" > {showPassword.einvoice ? <VisibilityOff /> : <Visibility />} </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    </Paper>
                </Box>

                {/* Bank Details */}
                <Box sx={{ mt: 2 }}>
                    <Paper elevation={2} sx={{ p: 2, borderRadius: 2, border: '1px solid #e0e0e0' }}>
                        <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 600, color: 'text.secondary' }} > Bank Details </Typography>
                        {/* Row 1 */}
                        <Box display="flex" gap={1.5} mb={1.5}>
                            <Box flex={1}> {renderField('Bank Name', 'BkName1')} </Box>
                            <Box flex={1}> {renderField('Branch', 'BkBranch1')} </Box>
                        </Box>
                        {/* Row 2 */}
                        <Box display="flex" gap={1.5} mb={1.5}>
                            <Box flex={1}> {renderField('Account No', 'BkAcNo1')} </Box>
                            <Box flex={1}> {renderField('IFSC Code', 'BkIFSCCode1')} </Box>
                        </Box>
                        {/* Row 3 */}
                        <Box display="flex" gap={1.5}>
                            <Box flex={1}> {renderField('UPI ID', 'UPIID')} </Box>
                            <Box flex={1}></Box>
                        </Box>
                    </Paper>
                </Box>
                {/* File upload area (preview + select) */}
                <Box display="flex" flexWrap="wrap" gap={3} justifyContent="center" alignItems="flex-start" mt={2}>
                    {/* Company Icon */}
                    <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
                        <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary' }}>Company Icon</Typography>
                        {companyIconPreview ? (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} >
                                <Box component="img" src={companyIconPreview} alt="Company Icon Preview" onClick={openPreview} sx={{ width: LOGO_WIDTH, height: LOGO_HEIGHT, borderRadius: 2, objectFit: 'contain', border: '1px solid #ccc', cursor: 'pointer' }} />
                                <Box display="flex" flexDirection="column" gap={1} >
                                    <Button size="small" variant="outlined" onClick={openPreview} > View </Button>
                                    <Tooltip title="Remove image" >
                                        <IconButton color="error" size="small" onClick={handleRemoveImage}>
                                            <RemoveCircleOutlineIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </Box>
                        ) : null}
                        <Button variant="outlined" component="label">
                            {companyIconPreview ? 'Change Icon' : 'Upload Company Icon'}
                            <input ref={fileInputRef} type="file" accept="image/*" hidden onChange={handleFileChange} />
                        </Button>
                    </Box>

                    {/* Authorized Signature */}
                    <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
                        <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary' }}>Authorized Signature</Typography>
                        {companySignaturePreview ? (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Box
                                    component="img"
                                    src={companySignaturePreview}
                                    alt="Signature Preview"
                                    sx={{ width: 120, height: 55, borderRadius: 2, objectFit: 'contain', border: '1px solid #ccc' }}
                                />
                                <Box display="flex" flexDirection="column" gap={1}>
                                    <Tooltip title="Remove signature">
                                        <IconButton color="error" size="small" onClick={handleSignatureRemove}>
                                            <RemoveCircleOutlineIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </Box>
                        ) : null}
                        <Button variant="outlined" component="label">
                            {companySignaturePreview ? 'Change Signature' : 'Upload Signature'}
                            <input ref={signatureFileRef} type="file" accept="image/*" hidden onChange={handleSignatureFileChange} />
                        </Button>
                    </Box>
                </Box>

                < Box display="flex" justifyContent="center" gap={1.5} mt={2} >
                    <Button onClick={handleSubmit} variant="contained" color="primary" sx={{ minWidth: 120, height: 38 }} disabled={isSubmitting || isUploading} startIcon={(isSubmitting || isUploading) ? <CircularProgress size={18} /> : null}> {mode === 'add' ? 'Submit' : 'Update'} </Button>
                    <Button onClick={handleCancel} variant="contained" color="error" sx={{ minWidth: 120, height: 38 }} disabled={isSubmitting || isUploading}> Cancel </Button>
                </Box>
            </Box>

            {/* Preview Dialog */}
            <Dialog open={previewOpen} onClose={closePreview} maxWidth="lg" fullWidth >
                <DialogActions sx={{ justifyContent: 'space-between', px: 2 }}>
                    <Box >
                        <Tooltip title="Download" > <IconButton onClick={downloadPreview}> <GetAppIcon /></IconButton > </Tooltip>
                        <IconButton onClick={closePreview} > <CloseIcon /></IconButton >
                    </Box>
                </DialogActions>
                <DialogContent sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 2 }}>
                    {
                        companyIconPreview ? (
                            <Box component="img" src={companyIconPreview} alt="Full Preview" sx={{ maxHeight: '80vh', maxWidth: '100%', objectFit: 'contain' }} />
                        ) : (
                            <Typography>No preview available </Typography>
                        )}
                </DialogContent>
            </Dialog>

            <Snackbar open={snackbar.open} onClose={() => setSnackbar(prev => ({ ...prev, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={3000}>
                <Alert onClose={() => setSnackbar(prev => ({ ...prev, open: false }))} severity={snackbar.severity} sx={{ width: '100%' }} variant='filled'> {snackbar.message} </Alert>
            </Snackbar>
            {showCityModal && (<CityPopupModal onClose={() => setShowCityModal(false)} onCityAdded={handleCityAdded} prefill={{ state: formState.state, stateCode: formState.gstNo.slice(0, 2), city: formState.city || city || '' }} />)}
        </Paper >
    );
};
export default CompanyMaster;